// eslint-disable-next-line
import React, { useReducer, useContext, useEffect } from 'react';
import { localStateReducer } from '../../../../../../utils/common';
import { ResizeContext } from '../../../../../../context/ResizeContext';

interface StudentRosterHeaderProps {
  columnType: string;
  headerText: string;
  // eslint-disable-next-line
  studentStatusArray?: any[];
  toggleVisible: (columnType: string) => void;
  visible: boolean;
}

export function StudentRosterHeader({
  columnType = '',
  headerText = '',
  studentStatusArray = [],
  // eslint-disable-next-line
  toggleVisible = (columnType: string) => {},
  visible = false,
}: StudentRosterHeaderProps) {
  const windowSize = useContext(ResizeContext);

  const [localState, setLocalState] = useReducer(localStateReducer, {
    isMobile: windowSize.mobile,
  });

  useEffect(() => {
    setLocalState({
      isMobile: windowSize.mobile,
    });
  }, [windowSize.mobile]);

  const a11yBtnProps = !localState.isMobile
    ? null
    : {
        'aria-expanded': visible,
      };

  return (
    <th id={`roster-column-${columnType}-header`} className='p-0'>
      <div aria-level='3' className='student-roster-swimLane-header'>
        <div className={'hidden-xs hidden-sm'}>
          {headerText} ({studentStatusArray?.length || '0'})
        </div>
        <button
          className={'hidden-md-up'}
          onClick={() => toggleVisible(columnType)}
          aria-controls={`roster-column-${columnType}`}
          {...a11yBtnProps}
        >
          {headerText} ({studentStatusArray?.length || '0'})
        </button>
      </div>
    </th>
  );
}
